import {Box, Button, ButtonGroup, ClickAwayListener, Divider, Grow, Paper, Popper} from "@mui/material";
import QrCodeIcon from "@mui/icons-material/QrCode";
import {CustomLink} from "../CustomLink/CustomLink";
import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import Deposit from "../../views/user/transactions/deposit/Deposit";
import CloseIcon from "@mui/icons-material/Close";
import {useQuery} from "@apollo/client";
import {GetUserQuery, User} from "../../gql/graphql";
import {GET_USER} from "../../store/queries/GetUser";
import {useLocation} from "react-router-dom";

const DepositButton = () => {
    const {t, i18n} = useTranslation();
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef<HTMLDivElement>(null);
    let location = useLocation();
    const getUser = useQuery<GetUserQuery>(GET_USER);
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };
    const handleClose = () => {
        setOpen(false);
    };
    
    useEffect(()=>{
        setOpen(false);
        },[location]);
    
    return (
        <>
           <ButtonGroup ref={anchorRef} variant="contained" sx={{
                height: '32px',
                backgroundColor: (theme) => theme.palette.primary.main,
                borderRadius: 4, ml:1
            }}>
                <Button
                    onClick={handleToggle}
                    sx={{display:{xs:'none',md:'flex'},borderRadius: '16px 0px 0px 16px', paddingRight: 0, paddingLeft: '10px'}}>
                    <QrCodeIcon
                        sx={{color: (theme) => theme.palette.primary.contrastText, padding: '2px', marginRight: 1}}/>

                </Button>
                <Divider orientation="vertical" sx={{display:{xs:'none',md:'flex'},borderColor: 'rgb(255 255 255 / 43%)'}} variant="middle" flexItem/>
                <Button component={CustomLink} to="/deposit"
                        sx={{borderRadius: {md:'0px 16px 16px 0px',xs:'16px'}, paddingLeft: {md:1}}}>{t('deposit')}</Button>
            </ButtonGroup>
                <Popper
                    sx={{
                        zIndex: 1,
                        paddingTop: '12px',
                        minWidth:'378px'
                    }}
                    open={open}
                    anchorEl={anchorRef.current}
                    transition
                    disablePortal
                    placement={'bottom-end'}
                >
                    {({TransitionProps, placement}) => (
                        <Grow
                            {...TransitionProps}
                            style={{
                                transformOrigin: 'right top',
                            }}
                        >
                            <Paper>
                                <Box sx={{
                                    display: 'block',
                                    width: '100%',
                                    position: 'relative'
                                }}>

                                    <Button onClick={() => handleClose()}
                                            sx={{position: 'absolute', top: 0, right: 0, pt: 2}}>
                                        <CloseIcon
                                            sx={{color: (theme) => theme.palette.text.primary, width: 24, height: 24}}/></Button>
                                </Box>
                                <Box sx={{
                                p:3
                            }}>
                                <Deposit forQr={true}/>
                                </Box>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            </>);
}

export default DepositButton;